import { Injectable } from '@angular/core';
import { ICountry } from '@core/models/Country/country.interface';
import { MealPlan } from '@core/models/MealPlan/meal-plan.enum';
import { IRate } from '@core/models/Rate/Rate.interface';
import { DisneyRoomCluster } from '@core/models/disney-room-cluster/DisneyRoomCluster.model';

@Injectable({
  providedIn: 'root',
})
export class RoomDetailsService {
  constructor() {}

  public getPaymentMethods(
    rates: IRate[],
    hotelCountry: ICountry,
  ): IconBadge<PaymentMethod>[] {
    const badges: Map<PaymentMethod, IconBadge<PaymentMethod>> = new Map();
    rates.forEach((rate) => {
      const badge: IconBadge<PaymentMethod> = new IconBadge<PaymentMethod>();
      const paymentCode = rate.payment_method.code;

      if (paymentCode.toUpperCase() === PaymentMethod.PREPAID) {
        badge.key = PaymentMethod.PREPAID;
        badge.icon = 'bank-credit-card';
      }

      if (paymentCode.toUpperCase() === PaymentMethod.PAY_AT_DESTINATION) {
        badge.key = PaymentMethod.PAY_AT_DESTINATION;
        badge.icon = 'pay-at-destination';
      }
      badge.label = rate.payment_method.description;
      badges.set(badge.key, badge);
    });

    return Array.from(badges.values());
  }

  public getMealPlans(rates: IRate[]): IconBadge<MealPlan>[] {
    const badges: Map<MealPlan, IconBadge<MealPlan>> = new Map();
    rates.forEach((rate) => {
      const badge: IconBadge<MealPlan> = new IconBadge<MealPlan>();
      const mealPlanCode = rate.meal_plan.code || '';
      badge.key = mealPlanCode as any;
      badge.label = rate.meal_plan.description;
      switch (mealPlanCode) {
        case MealPlan.BREAKFAST:
          badge.icon = 'breakfast';
          break;
        case MealPlan.ROOM_ONLY:
          badge.icon = 'room-only';
          break;
        case MealPlan.HALF_BOARD:
          badge.icon = 'half-meal-plan';
          break;
        case MealPlan.FULL_BOARD:
          badge.icon = 'restaurant';
          break;
        case MealPlan.ALL_INCLUSIVE:
          badge.icon = 'all-inclusive';
          break;
      }
      if (
        [
          MealPlan.BREAKFAST,
          MealPlan.ROOM_ONLY,
          MealPlan.HALF_BOARD,
          MealPlan.FULL_BOARD,
          MealPlan.ALL_INCLUSIVE,
        ].includes(badge.key)
      ) {
        badges.set(badge.key, badge);
      }
    });
    return Array.from(badges.values());
  }

  public getDisneySupplements(roomCluster: DisneyRoomCluster): IconBadge<string>[] {
    if (roomCluster.rates === undefined) {
      return [];
    }
    let badges: IconBadge<string>[] = [];
    if (roomCluster.hasTickets) {
      const badge = new IconBadge<string>();
      badge.icon = 'upgrade-disney';
      badge.label = 'Entradas a los parques';
      badges.push(badge);
    }
    if (roomCluster.hasMealPlans) {
      const badge = new IconBadge<string>();
      badge.icon = 'restaurant';
      badge.label = 'Entradas a los parques + Plan de comida';
      badges = [badge].concat(badges);
    }
    return badges;
  }
}

export enum PaymentMethod {
  PREPAID = 'PREPAID',
  PREPAID_NATIONAL = 'PREPAID_NATIONAL',
  PREPAID_USD = 'PREPAID_USD',
  PREPAID_INTERNATIONAL = 'PREPAID_INTERNATIONAL',
  PAY_AT_DESTINATION = 'PAY_AT_DESTINATION',
}

export class IconBadge<T> {
  key: T;
  label: string;
  icon: string;
}
